import React, { useEffect, useState } from 'react';
import { getPaymentMethods, updatePaymentChannel } from '../../api/sportaloka-client';
import Swal from 'sweetalert2';

const PaymentMethod = () => {
  const [fetchLoading, setFetchLoading] = useState(false);
  const [fetchError, setFetchError] = useState(false);
  const [methods, setMethods] = useState([]);

  const getData = async () => {
    try {
      setFetchLoading(true);
      setFetchError(false);
      const response = await getPaymentMethods();
      const responseData = response.data.data.map((method) => {
        const channels = method.channels.map((ch) => {
          return { ...ch, loading: false };
        });
        return { ...method, channels };
      });
      setMethods(responseData);
      setFetchLoading(false);
    } catch (error) {
      setFetchError(true);
      setFetchLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const setChannelLoading = (methodIndex, channelIndex, value) => {
    const newData = [...methods];
    newData[methodIndex].channels[channelIndex].loading = value;
    setMethods(newData);
  };

  const handleChangeStatus = async (methodIndex, channelIndex) => {
    Swal.fire({
      title: 'Apakah anda yakin mengubah status payment channel?',
      text: 'Jika channel tidak aktif maka channel tidak akan di tampilkan di website',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ya, Ubah status!',
      cancelButtonText: 'Batalkan'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const selectedChannel = methods[methodIndex].channels[channelIndex];
          setChannelLoading(methodIndex, channelIndex, true);
          await updatePaymentChannel(
            selectedChannel.id,
            selectedChannel.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE'
          );
          const newData = [...methods];
          newData[methodIndex].channels[channelIndex].status =
            selectedChannel.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE';
          setMethods(newData);

          setChannelLoading(methodIndex, channelIndex, false);
          Swal.fire({
            title: 'Berhasil!',
            text: 'Data diperbarui.',
            icon: 'success'
          });
        } catch (error) {
          Swal.fire({
            title: 'Gagal!',
            text: `Periksa koneksi internet anda dan coba kembali.`,
            icon: 'error',
            confirmButtonText: 'Tutup'
          });
          setChannelLoading(methodIndex, channelIndex, false);
        }
      }
    });
  };

  return (
    <div>
      <div>
        <div className="d-flex justify-content-between align-items-center">
          <h1 className="text-30 lh-14 fw-600">Payment Method</h1>
        </div>
      </div>
      <div className="py-30 px-30 rounded-4 bg-white shadow-3 mt-20">
        {fetchLoading && !fetchError && <div className="text-center fw-700 my-4">Loading...</div>}
        {!fetchLoading && fetchError && (
          <div className="text-center fw-700 my-4">
            Gagal mendapatkan data{' '}
            <span className="text-danger cursor-pointer" onClick={getData}>
              Coba lagi
            </span>
          </div>
        )}
        {!fetchLoading && !fetchError && (
          <div className="accordion mt-20" id="accordionExample">
            {methods.map((item, methodIndex) => (
              <div className="accordion-item" key={item.name}>
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#${item.name}`}
                    aria-expanded="false"
                    aria-controls={item.name}>
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <span className="fw-600">{item.label}</span>
                      {item.name === 'CREDIT_OR_DEBIT' ? (
                        <div className="d-flex align-items-center">
                          <span>
                            <img
                              src="https://d2f3dnusg0rbp7.cloudfront.net/snap-preferences/sandbox/v1/logos/visa.svg"
                              style={{ width: 50, height: 18, marginRight: 8 }}
                              alt=""
                            />
                            <img
                              src="https://d2f3dnusg0rbp7.cloudfront.net/snap-preferences/sandbox/v1/logos/mastercard.svg"
                              style={{ width: 32, height: 30, marginRight: 9 }}
                              alt=""
                            />
                            <img
                              src="https://d2f3dnusg0rbp7.cloudfront.net/snap-preferences/sandbox/v1/logos/jcb.svg"
                              style={{ width: 42, height: 20, marginRight: 8 }}
                              alt=""
                            />
                            <img
                              src="https://d2f3dnusg0rbp7.cloudfront.net/snap-preferences/sandbox/v1/logos/amex.svg"
                              style={{ width: 42, height: 20, marginRight: 8 }}
                              alt=""
                            />
                          </span>
                        </div>
                      ) : (
                        <div className="d-flex align-items-center">
                          <span>
                            {item.channels.map((channel) => (
                              <img
                                key={channel.id}
                                src={channel.image}
                                style={{ width: 42, height: 20, marginRight: 8 }}
                                alt=""
                              />
                            ))}
                          </span>
                        </div>
                      )}
                    </div>
                  </button>
                </h2>
                <div
                  id={item.name}
                  className="accordion-collapse collapse"
                  data-bs-parent="#accordionExample">
                  <div className="accordion-body">
                    <div className="p-4 row">
                      <table className="table">
                        <tbody>
                          {item.channels.map((channel, channelIndex) => (
                            <tr key={channel.id}>
                              <th style={{ verticalAlign: 'middle' }}>
                                <div className="d-flex align-items-center">
                                  <img
                                    src={channel.image}
                                    style={{ height: 40, width: 40 }}
                                    alt=""
                                  />
                                  <span className="ms-4">{channel.label}</span>
                                </div>
                              </th>
                              <th style={{ verticalAlign: 'middle' }} className="text-right">
                                {!channel.loading ? (
                                  <div className="form-check custom-form-switch form-switch d-flex justify-content-end">
                                    <input
                                      checked={channel.status === 'ACTIVE' ? true : false}
                                      onChange={() => handleChangeStatus(methodIndex, channelIndex)}
                                      style={{
                                        width: 60,
                                        height: 32,
                                        borderWidth: 1,
                                        borderStyle: 'solid',
                                        borderColor: '#cccccc'
                                      }}
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      id="flexSwitchCheckDefault"
                                    />
                                  </div>
                                ) : (
                                  <span>Loading...</span>
                                )}
                              </th>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentMethod;
